interface StepsConfig {
  baseUrl: string
  clientId: string
  clientToken: string
  tokenExpiryBuffer: number // Buffer time in milliseconds before token expiry
  maxRetries: number
  retryDelay: number
  maxRetryDelay: number // Maximum delay between retries in milliseconds
  requestTimeout: number // Request timeout in milliseconds
}

const validateConfig = (config: StepsConfig): void => {
  if (!config.baseUrl) {
    throw new Error('STEPS API base URL is required')
  }
  if (!config.clientId) {
    throw new Error('STEPS API client ID is required')
  }
  if (!config.clientToken) {
    throw new Error('STEPS API client token is required')
  }
}

const config: StepsConfig = {
  baseUrl:
    process.env.REACT_APP_STEPS_BASE_URL || 'https://210472-api.stepscloud.de',
  clientId: process.env.REACT_APP_STEPS_CLIENT_ID || '',
  clientToken: process.env.REACT_APP_STEPS_CLIENT_TOKEN || '',
  tokenExpiryBuffer: 5 * 60 * 1000, // 5 minutes in milliseconds
  maxRetries: 3,
  retryDelay: 1000, // 1 second
  maxRetryDelay: 30 * 1000, // 30 seconds
  requestTimeout: 10 * 1000, // 10 seconds
}

validateConfig(config)

export default config
